import { render, staticRenderFns } from "./department.vue?vue&type=template&id=260cefae&scoped=true"
import script from "./index.js?vue&type=script&lang=js&external"
export * from "./index.js?vue&type=script&lang=js&external"
import style0 from "./department.vue?vue&type=style&index=0&id=260cefae&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "260cefae",
  null
  
)

export default component.exports